import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export const Countdown: React.FC<CountdownProps> = ({
  initialHours = 23,
  initialMinutes = 48,
  initialSeconds = 47
}) => {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-brand-orange font-heading font-bold text-2xl md:text-4xl" data-id="element-67">
      <div className="flex flex-col items-center bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-orange/20" data-id="element-68">
        <span data-id="element-69">{formatNumber(timeLeft.hours)}</span>
        <span className="text-xs text-gray-500 font-sans uppercase tracking-wider mt-1" data-id="element-70">
          Horas
        </span>
      </div>
      <span className="text-brand-orange/50 pb-5" data-id="element-71">:</span>
      <div className="flex flex-col items-center bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-orange/20" data-id="element-72">
        <span data-id="element-73">{formatNumber(timeLeft.minutes)}</span>
        <span className="text-xs text-gray-500 font-sans uppercase tracking-wider mt-1" data-id="element-74">
          Min
        </span>
      </div>
      <span className="text-brand-orange/50 pb-5" data-id="element-75">:</span>
      <div className="flex flex-col items-center bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-orange/20" data-id="element-76">
        <span data-id="element-77">{formatNumber(timeLeft.seconds)}</span>
        <span className="text-xs text-gray-500 font-sans uppercase tracking-wider mt-1" data-id="element-78">
          Seg
        </span>
      </div>
    </div>;
};